export default function arrayDiff(arr1, arr2) {
  // Convert arrays to sets
  const set1 = new Set(arr1)
  const set2 = new Set(arr2)

  // Find items removed (in set1 but not in set2)
  const removed = new Set([...set1].filter((item) => !set2.has(item)))

  // Find items added (in set2 but not in set1)
  const added = new Set([...set2].filter((item) => !set1.has(item)))

  return { removed: Array.from(removed), added: Array.from(added) }
}
